import React from 'react';
import '../App.css';
import Post from './IndividualPost.js';

const List=(props)=>{

    const renderTasks=()=>{
      return props.tasks.map((item, index)=>{
          return(
              <Post
                key={item.id}
                post={item}
                removeTask={()=>{props.removeTask(item.id)}}
                upvote={()=>{props.upvote(item.id)}}
                downvote={()=>{props.downvote(item.id)}}
              />
          );
        })
    }

    return(
      <div className="Tasks">

        {renderTasks()}
      </div>
    );
}

export default List;



// WEBPACK FOOTER //
// ./src/Components/List.js